import { connect } from "react-redux";

import ListFarmaceutas from "./ListAdminPharmacys";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(ListFarmaceutas);
